import { Fragment, type ComponentType } from 'react';
import { Button, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, makeStyles, tokens } from '@fluentui/react-components';
import { MoreHorizontal20Regular } from '@fluentui/react-icons';

export type OverflowMenuItem = {
  label: string;
  icon?: ComponentType;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
  /** Show a divider before this item */
  dividerBefore?: boolean;
};

type OverflowMenuProps = {
  items: OverflowMenuItem[];
};

const useStyles = makeStyles({
  dangerItem: {
    color: tokens.colorPaletteRedForeground1,
  },
});

export const OverflowMenu = ({ items }: OverflowMenuProps) => {
  const styles = useStyles();

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="subtle"
          icon={<MoreHorizontal20Regular />}
          aria-label="More actions"
          onClick={(e) => e.stopPropagation()}
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {items.map((item) => (
            <Fragment key={item.label}>
              {item.dividerBefore && <MenuDivider />}
              <MenuItem
                onClick={item.onClick}
                {...(item.icon ? { icon: <item.icon /> } : {})}
                {...(item.disabled ? { disabled: true } : {})}
                {...(item.danger ? { className: styles.dangerItem } : {})}
              >
                {item.label}
              </MenuItem>
            </Fragment>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
